module.exports = __webpack_public_path__ + "media/assets/img/slider/02-28f1f6c1bd64dd3e3bf91bb4e51d6315.jpg";